import { render, staticRenderFns } from "./YourInfoSection.vue?vue&type=template&id=22fb522a&scoped=true&"
import script from "./YourInfoSection.vue?vue&type=script&lang=js&"
export * from "./YourInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./YourInfoSection.vue?vue&type=style&index=0&id=22fb522a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb522a",
  null
  
)

export default component.exports